// eslint-disable-next-line no-restricted-imports
import { Checkbox as CheckboxMUI, CheckboxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { forwardRef } from 'react';

import { CheckboxCheck } from '@app-velocity/icons';

// Base icon box for unchecked state
const IconBox = styled('span')(({ theme }) => ({
  width: theme.spacing(4.5),
  height: theme.spacing(4.5),
  borderRadius: theme.spacing(1),
  border: '1px solid #BFCCE3',
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

// Styled icon box for checked state
const CheckedIconBox = styled(IconBox)({
  backgroundColor: 'var(--button-button-primary-color)',
  border: 'none',
  color: '#fff',
});

const StyledCheckbox = styled(CheckboxMUI)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props: CheckboxProps, ref) => {
    return (
      <StyledCheckbox
        //   disableRipple
        color="default"
        icon={<IconBox />}
        inputRef={ref}
        checkedIcon={
          <CheckedIconBox>
            <CheckboxCheck />
          </CheckedIconBox>
        }
        {...props}
      />
    );
  }
);
